import * as React from "react"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import useOnClickWithTouchHandler from "../../../hooks/useOnClickWithTouchHandler"
import { Tooltip } from "../../common/tooltip"
import {
  ContainerIcon,
  MuteButton,
  VolumeIcon,
  MuteIcon
} from "../videoPlayer/custom-player.styled"
import { useAvatarSpeakerManager } from "src/conditionals/Avatar"

interface GlobalLocalMuteIconProps {
  style?: React.CSSProperties
}

export const AvatarMuteIcon: React.FC<GlobalLocalMuteIconProps> = ({ style }) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isEnabled, toggleSpeaker } = useAvatarSpeakerManager()

  const handleToggleSound = (event) => {
      event.stopPropagation()
      event.preventDefault()
      toggleSpeaker()
  }

  const toggleMute = useOnClickWithTouchHandler(handleToggleSound)

  return (
    <Tooltip label={"Avatar audio"} placement="right">
      <MuteButton {...toggleMute} roomStyles={roomStyles} style={style}>
        <ContainerIcon roomStyles={roomStyles}>
          {isEnabled ? <VolumeIcon /> : <MuteIcon />}
        </ContainerIcon>
      </MuteButton>
    </Tooltip>
  )
}
